<template>
  <el-tree
    :check-strictly="true"
    node-key="id"
    :props="props"
    :load="loadNode"
    @check-change="handleCheckChange"
    ref="dataTree"
    lazy
    show-checkbox
  >
  </el-tree>
</template>
<script>
import { getTissueTree } from "@/api/subcontractor-register";
export default {
  data() {
    return {
      company: "",
      parentOrgId: 1,
      treeData: [],
      props: {
        label: "useOrgName",
        children: "child",
        isLeaf: "leaf",
      },
    };
  },
  methods: {
    //   展开时
    loadNode(node, resolve) {
      //   this.parentOrgId = !!node.data.useOrgId? node.data.useOrgId : 1;
      // this.parentOrgId=
      if (node.data && node.data.useOrgId) {
        this.parentOrgId = node.data.useOrgId;
      }
      getTissueTree({ parentOrgId: this.parentOrgId, flag: 1 }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data == []) {
            return resolve([]);
          } else {
            resolve(res.data.data);
          }
        }
      });
    },
    handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        this.$refs.dataTree.setCheckedKeys([data.id]);
        this.company = data;
      }
    },
  },
};
</script>
